// Bottom sheet that hosts the "instrument" of a task (opdracht).

import { $, el, sleep } from './util.js';

export interface Sheet {
  body: HTMLElement;
  feedback(text: string, kind?: '' | 'good' | 'bad'): void;
  setDark(on: boolean): void;
  close(): Promise<void>;
}

export function openSheet(opts: { label: string; title: string; quote?: string }): Sheet {
  const root = $('#sheet');
  const body = el('div', {});
  const fb = el('p.sheet__feedback', { 'aria-live': 'polite' });
  const panel = el('div.sheet__panel', {},
    el('div.sheet__grip'),
    el('p.sheet__label', {}, opts.label),
    el('h2.sheet__title#sheet-title', {}, opts.title),
    opts.quote ? el('p.sheet__quote', {}, opts.quote) : null,
    body, fb,
  );
  root.replaceChildren(panel);
  root.hidden = false;
  return {
    body,
    feedback(text, kind = '') { fb.textContent = text; fb.className = `sheet__feedback${kind ? ` is-${kind}` : ''}`; },
    setDark(on) { root.classList.toggle('sheet--dark', on); },
    async close() {
      panel.style.transition = 'transform .35s cubic-bezier(.4,0,1,1)';
      panel.style.transform = 'translateY(105%)';
      await sleep(330);
      root.hidden = true;
      root.classList.remove('sheet--dark');
      root.replaceChildren();
    },
  };
}
